import React, { createRef, PureComponent } from "react";
import { connect } from "react-redux";
import { RECEIVER, SENDER } from "../../../constants/types";
import AddressListItem from "../Address/AddressListItem";
import {
  addParcelItem,
  clearCustoms,
  clearLabelCreationErrors,
  clearNewTemplate,
  clearPurchaseStates,
  clearRate,
  clearRates,
  clearReceiverAddress,
  clearSelectedTemplate,
  clearSenderAddress,
  createCustomsDeclaration,
  createTemplate,
  editCustomsItems,
  getAddresses,
  getOrderForCreation,
  getRates,
  selectAddress,
  selectDropoffLocation,
  selectOrder,
  selectPickupPoint,
  selectRate,
  selectTemplate,
  updateExtras,
  updateNewTemplate,
  updateTemplateName,
  selectItemDetail,
  deleteItemDetail,
  clearItemDetails,
} from "../../actions";
import AddressListModal from "./AddressListModal";
import PickupPointListModal from "./PickupPointListModal";
import DropoffLocationListModal from "./DropoffLocationListModal";
import AddressForm from "../Address/AddressForm";
import "../../../scss/label.scss";
import PackageDetails from "./PackageDetails";
import RateSelection from "./RateSelection";
import CustomsInfo from "./CustomsInfo";
import CustomsItemForm from "./CustomsItemForm";
import CustomsItemFormItem from "./CustomsItemFormItem";
import ItemDetailsForm from "./ItemDetailsForm";
import PurchaseLabel from "./PurchaseLabel";
import LabelTemplate from "./LabelTemplate";
import { FiX, FiAlertCircle } from "react-icons/fi";
import { withRouter } from "react-router-dom";

import { compose } from "recompose";
import { withCookies } from "react-cookie";
import TemplateList from "./TemplateList";

import { ReactComponent as TemplateListIcon } from "../../../assets/template-prompt-icon.svg";
import {
  getUserCountry,
  setApplicationContext,
} from "../../actions/ApplicationContextActions";
import {
  doesPickupPointMatchSender,
  isDomesticKenyanShipment,
  isInternationalShipment,
  isPickupSelected,
  isSenderEligibleForPickup,
  isValidPhoneNumber,
  missingDetails,
  validatePackage,
} from "../common/helpers";
import history from "../../../History";
import * as ROUTES from "../../../constants/routes";
import MessageBlock from "../common/MessageBlock";
import { parseError } from "../../actions/ActionHelpers";
import ExtraOptions from "./ExtraOptions";
import TaxNumberForm from "./TaxNumberForm";
import DestinationAddress from "./DestinationAddress";

class CreateLabel extends PureComponent {
  state = {
    showForm: false,
    showList: false,
    listType: SENDER,
    formType: SENDER,
    receiverError: "",
    senderError: "",
    fieldsError: { valid: true },
    parcelsError: [],
    customsError: { valid: true },
    extraErrors: null,
    loadedTemplate: "",
    templateError: "",
    showRates: false,
    showCustoms: false,
    showCustomsForm: false,
    showItemDetailsForm: false,
    showPurchase: false,
    createTemplate: false,
    showTemplateList: false,
    showSaveTemplatePrompt: false,
    askSaveTemplate: true,
    showVerificationPrompt: false,
    showKenyanVerificationPrompt: false,
    showPickupPointList: false,
    showDropoffLocationList: false,
    usePickupDestination: false,
    customerDetails: {
      name: "",
      email: "",
      phone: "",
    },
    customerDetailsErrors: {},
  };

  constructor() {
    super();
    this.templateFormRef = createRef();
  }

  isMilitaryAddress(address) {
    if (!address?.country) {
      return false;
    }
    if (address.country === "US" || address.country === "USA") {
      const state = address.state.toUpperCase().trim();
      if (["AA", "AE", "AP"].includes(state)) {
        return true;
      }
      const city = address.city.toUpperCase().trim();
      if (["APO", "FPO", "DPO"].includes(city)) {
        return true;
      }
    }
    return false;
  }

  requiresCustoms(sender, receiver, pickupPoint = this.props.pickupPoint) {
    return (
      isInternationalShipment(sender, receiver, pickupPoint) ||
      this.isMilitaryAddress(sender) ||
      this.isMilitaryAddress(receiver)
    );
  }

  getDestinationAddress = () => {
    if (this.state.usePickupDestination) {
      return this.props.pickupPoint?.address || null;
    }

    return this.props.receiver;
  };

  clearDestinationSelections = () => {
    this.props.clearReceiverAddress();
    this.props.selectPickupPoint(null);
    this.props.selectDropoffLocation(null);
    this.setState({
      receiverError: "",
      customerDetailsErrors: {},
    });
  };

  handlePickupDestinationToggle = (enabled) => {
    this.clearDestinationSelections();
    this.props.clearRate();
    this.props.clearRates();
    this.props.clearLabelCreationErrors();
    if (this.state.showRates) {
      this.toggleRates();
    }

    this.setState({
      usePickupDestination: enabled,
      customerDetails: {
        name: "",
        email: "",
        phone: "",
      },
      customerDetailsErrors: {},
    });
  };

  handleCustomerDetailsChange = (field, value) => {
    this.setState((prevState) => ({
      customerDetails: {
        ...prevState.customerDetails,
        [field]: value,
      },
      customerDetailsErrors: {
        ...prevState.customerDetailsErrors,
        [field]: null,
      },
      receiverError: "",
    }));
  };

  populateCustomerDetailsFromAddress = (address) => {
    this.setState({
      customerDetails: {
        name: address?.name || "",
        email: address?.email || "",
        phone: address?.phone || "",
      },
      customerDetailsErrors: {},
      receiverError: "",
    });
  };

  componentDidMount = () => {
    const searchParams = new URLSearchParams(
      this.props.history.location.search,
    );
    const orderID = searchParams.get("o_id");
    const organizationId = this.props.applicationContext.context.organizationId;
    if (organizationId) {
      this.props.clearSenderAddress();
      this.props.clearReceiverAddress();
      this.props.clearRate();
      this.props.clearRates();
      this.props.clearLabelCreationErrors();
    }
    this.props.selectPickupPoint(null);
    this.props.selectDropoffLocation(null);

    if (
      !!orderID &&
      (!this.props.selectedOrder || this.props.selectedOrder.id !== orderID)
    ) {
      this.props.getOrderForCreation(orderID);
    } else {
      this.props.selectOrder(null);
    }

    this.props.clearRate();
    this.props.clearRates();
    this.props.clearLabelCreationErrors();
    this.props.getUserCountry();
    if (
      this.requiresCustoms(
        this.props.sender,
        this.props.receiver,
        this.props.pickupPoint,
      )
    ) {
      this.setState({ showCustoms: true });
    }

    if (
      !this.props.sender ||
      (!this.props.sender.external_id && !this.props.sender.id) ||
      (this.props.sender.external_id === "" && this.props.sender.id === "")
    ) {
      this.props.clearSenderAddress();
    }

    if (
      !this.props.receiver ||
      (!this.props.receiver.external_id && !this.props.receiver.id) ||
      (this.props.sender.external_id === "" && this.props.receiver.id === "")
    ) {
      // this.props.clearReceiverAddress()
    }

    if (!!this.props.defaultAddress) {
      this.props.selectAddress(this.props.defaultAddress, SENDER);
    }

    if (!this.props.customs.items.every((item) => item.origin_country)) {
      this.props.customs.items.forEach((item, idx) => {
        if (!item.origin_country) {
          this.props.editCustomsItems(
            {
              ...item,
              origin_country:
                this.props.defaultAddress?.country ||
                this.props.currentCountry ||
                "US",
            },
            idx,
          );
        }
      });
    }

    if (
      this.props.sender?.id &&
      !this.props.customs.items.every((item) => item.origin_country)
    ) {
      this.props.customs.items.forEach((item, idx) => {
        if (!item.origin_country) {
          this.props.editCustomsItems(
            {
              ...item,
              origin_country:
                this.props.sender?.country || this.props.currentCountry || "US",
            },
            idx,
          );
        }
      });
    }

    if (this.props.labelTemplate.selectedTemplate) {
      this.props.selectTemplate(this.props.labelTemplate.selectedTemplate);
    }
  };

  validateParcelList = async () => {
    let valid = true;

    const checkPackageFields = validatePackage(
      this.props.selectedParcel,
      this.props.selectedWeight,
      this.props.packageType,
    );

    if (this.props.parcels?.parcels?.length === 0) {
      valid = checkPackageFields.valid;
      if (valid) {
        await this.props.addParcelItem({
          ...this.props.selectedParcel,
          ...this.props.selectedWeight,
        });
      } else {
        this.setState({ fieldsError: { ...checkPackageFields } });
      }
    }

    return valid;
  };

  validateCustoms = () => {
    const customsError = {
      valid: true,
    };
    if (this.props.customs.items.length < 1) {
      customsError.items = true;
      customsError.valid = false;
    }
    if (!this.props.customs.certified) {
      customsError.certified = true;
      customsError.valid = false;
    }
    if (!this.props.customs.customsSigner.trim()) {
      customsError.signer = true;
      customsError.valid = false;
    }
    return customsError;
  };

  validateExtras = (destinationAddress, pickupPoint = null) => {
    const descriptionLength =
      this.props.selectedExtras?.description?.length || 0;
    const isDomesticKenyan = isDomesticKenyanShipment(
      this.props.sender,
      destinationAddress,
      pickupPoint,
    );
    const maxLength = isDomesticKenyan ? 191 : 70;
    let valid = true;
    if (
      this.props.selectedExtras?.collection_on_delivery &&
      (!this.props.selectedExtras?.collection_on_delivery.amount ||
        parseFloat(this.props.selectedExtras?.collection_on_delivery.amount) ===
          0)
    ) {
      this.setState({
        extraErrors: {
          collection_on_delivery: `Minimum value for collection amount is 1`,
        },
      });
      valid = false;
    }
    if (descriptionLength > maxLength) {
      this.setState({
        extraErrors: {
          description: `Ensure this field has no more than ${maxLength} characters.`,
        },
      });
      valid = false;
    }
    return valid;
  };

  validatePickupPointSelection = () => {
    if (!this.state.usePickupDestination) {
      return true;
    }

    const { sender, pickupPoint } = this.props;
    if (!isPickupSelected(pickupPoint)) {
      this.setErrorMessage(RECEIVER, "Select a pickup point to continue.");
      return false;
    }

    if (!isSenderEligibleForPickup(sender)) {
      this.setErrorMessage(
        RECEIVER,
        "Pickup points are currently available only for Nairobi, Kenya senders.",
      );
      return false;
    }

    if (!doesPickupPointMatchSender(sender, pickupPoint)) {
      this.setErrorMessage(
        RECEIVER,
        "Selected pickup point must match sender country and city.",
      );
      return false;
    }

    return true;
  };

  validateDropoffLocationSelection = () => {
    if (!this.state.usePickupDestination) {
      return true;
    }

    if (!this.props.dropoffLocation?.id) {
      this.setErrorMessage(RECEIVER, "Select a dropoff location to continue.");
      return false;
    }

    return true;
  };

  validateCustomerDetails = () => {
    if (!this.state.usePickupDestination) {
      return true;
    }

    const { customerDetails } = this.state;
    const errors = {};
    if (!customerDetails.name?.trim()) {
      errors.name = "Name is required.";
    }
    if (!customerDetails.phone?.trim()) {
      errors.phone = "Phone is required.";
    } else if (!isValidPhoneNumber(customerDetails.phone)) {
      errors.phone = "Please enter a valid phone number.";
    }

    if (Object.keys(errors).length > 0) {
      this.setState({
        customerDetailsErrors: errors,
      });
      this.setErrorMessage(
        RECEIVER,
        "Customer details are required for pickup point deliveries.",
      );
      return false;
    }

    return true;
  };

  validateRateChecks = async () => {
    // Clear errors before checking again
    this.setState({
      receiverError: "",
      senderError: "",
      customerDetailsErrors: {},
    });
    //TODO: Validate Addresses
    // - validate that all required fields are there in both to and from
    const pickupPointForChecks = this.state.usePickupDestination
      ? this.props.pickupPoint
      : null;
    const destinationAddress = this.getDestinationAddress();
    let valid = true;
    valid = this.validateAddress(this.props.sender, SENDER) && valid;
    if (this.state.usePickupDestination) {
      valid = valid && this.validateDropoffLocationSelection();
      valid = valid && this.validatePickupPointSelection();
      valid = valid && this.validateCustomerDetails();
      if (valid && pickupPointForChecks?.address) {
        valid = this.validateAddress(pickupPointForChecks.address, RECEIVER);
        valid = this.validateAddress(
          this.props.dropoffLocation.address,
          RECEIVER,
        );
      }
    } else {
      valid = valid && this.validateAddress(this.props.receiver, RECEIVER);
    }
    valid = valid && (await this.validateParcelList());
    valid =
      valid && this.validateExtras(destinationAddress, pickupPointForChecks);

    if (
      valid &&
      isDomesticKenyanShipment(
        this.props.sender,
        destinationAddress,
        pickupPointForChecks,
      )
    ) {
      if (!this.props.businessDetails.tax_number) {
        this.setState({
          showKenyanVerificationPrompt: true,
        });
        return false;
      }
    }
    // - validate that if international, to is US, and from has a phone # / email
    if (
      valid &&
      isInternationalShipment(
        this.props.sender,
        destinationAddress,
        pickupPointForChecks,
      )
    ) {
      if (!this.props.businessDetails.is_verified) {
        this.setState({
          showVerificationPrompt: true,
        });
        return false;
      }
      if (!destinationAddress?.phone) {
        this.setErrorMessage(
          RECEIVER,
          "phone number is required for international shipments",
        );
        valid = false;
      } else if (destinationAddress.phone === "") {
        this.setErrorMessage(
          RECEIVER,
          "phone number is required for international shipments",
        );
        valid = false;
      }
      if (!this.props.sender.phone) {
        this.setErrorMessage(
          SENDER,
          "phone number is required when sending to international shipments",
        );
        valid = false;
      } else if (this.props.sender.phone === "") {
        this.setErrorMessage(
          SENDER,
          "phone number is required when sending to international shipments",
        );
        valid = false;
      }
      if (!this.props.sender.name.includes(" ")) {
        this.setErrorMessage(
          SENDER,
          "both first and last name is required when sending to international shipments",
        );
        valid = false;
      }

      if (!destinationAddress?.name?.includes(" ")) {
        this.setErrorMessage(
          RECEIVER,
          "both first and last name is required when sending to international shipments",
        );
        valid = false;
      }
    }
    if (
      valid &&
      this.requiresCustoms(
        this.props.sender,
        destinationAddress,
        pickupPointForChecks,
      )
    ) {
      const customsValidation = this.validateCustoms();
      valid = valid && customsValidation.valid;
      this.setState({
        customsError: customsValidation,
      });
    }
    return valid;
  };

  componentWillUnmount() {
    this.props.clearRate();
    this.props.clearRates();
    this.props.clearLabelCreationErrors();
    if (this.props.selectedOrder) {
      this.props.selectOrder(null);
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const pickupPointForChecks = this.state.usePickupDestination
      ? this.props.pickupPoint
      : null;
    const destinationAddress = this.getDestinationAddress();
    const shouldShowCustoms = this.requiresCustoms(
      this.props.sender,
      destinationAddress,
      pickupPointForChecks,
    );
    if (shouldShowCustoms !== this.state.showCustoms) {
      this.setState({ showCustoms: shouldShowCustoms });
    }
    const destinationChanged =
      prevState.usePickupDestination !== this.state.usePickupDestination ||
      prevState.customerDetails !== this.state.customerDetails ||
      prevProps.pickupPoint !== this.props.pickupPoint ||
      prevProps.dropoffLocation !== this.props.dropoffLocation;
    const formChanged =
      prevProps.sender !== this.props.sender ||
      prevProps.receiver !== this.props.receiver ||
      prevProps.parcels !== this.props.parcels ||
      prevProps.customs !== this.props.customs ||
      destinationChanged;
    if (formChanged || prevProps.selectedRate !== this.props.selectedRate) {
      this.props.clearPurchaseStates();
    }
    if (formChanged) {
      this.props.clearRate();
      this.props.clearRates();
      this.props.clearLabelCreationErrors();

      if (this.state.showRates) {
        this.toggleRates();
      }

      const customsValidation =
        this.state.showCustomsForm && !this.state.customsError.valid
          ? this.validateCustoms()
          : { valid: true };

      this.setState({
        receiverError: "",
        senderError: "",
        fieldsError: { valid: true },
        customsError: customsValidation,
        extraErrors: null,
        customerDetailsErrors: {},
      });

      if (
        prevProps.sender !== this.props.sender &&
        this.props.sender?.id &&
        !this.props.customs.items.every((item) => item.origin_country)
      ) {
        this.props.customs.items.forEach((item, idx) => {
          if (!item.origin_country) {
            this.props.editCustomsItems(
              {
                ...item,
                origin_country:
                  this.props.sender?.country ||
                  this.props.currentCountry ||
                  "US",
              },
              idx,
            );
          }
        });
      }

      if (
        prevProps.labelTemplate.selectedTemplate &&
        this.props.labelTemplate.selectedTemplate
      ) {
        // keep state in sync when template remains selected after updates
      }
    }
    if (
      this.state.usePickupDestination &&
      (!isSenderEligibleForPickup(this.props.sender) ||
        (this.props.pickupPoint &&
          !doesPickupPointMatchSender(
            this.props.sender,
            this.props.pickupPoint,
          ))) &&
      prevProps.sender !== this.props.sender
    ) {
      this.handlePickupDestinationToggle(false);
    }
    if (
      this.state.showSaveTemplatePrompt &&
      prevProps.labelTemplate.selectedTemplate !==
        this.props.labelTemplate.selectedTemplate &&
      this.props.labelTemplate.selectedTemplate
    ) {
      this.setState({ showSaveTemplatePrompt: false });
      this.getRates();
    }

    if (
      prevProps.rateError !== this.props.rateError &&
      this.props.rateError &&
      Object.keys(this.props.rateError).length > 0
    ) {
      const propErrors = { ...this.props.rateError };

      if (propErrors.customs_declaration) {
        this.setState({
          customsError: {
            ...this.state.customsError,
            valid: false,
            items: Object.keys(propErrors.customs_declaration).includes(
              "items",
            ),
            signer: Object.keys(propErrors.customs_declaration).includes(
              "certify_signer",
            ),
            certified: Object.keys(propErrors.customs_declaration).includes(
              "certified",
            ),
            contents_explanation: Object.keys(
              propErrors.customs_declaration,
            ).includes("contents_explanation"),
            tax_numbers:
              Object.keys(propErrors.customs_declaration).includes(
                "exporter_identification",
              ) ||
              Object.keys(propErrors.customs_declaration).includes(
                "tax_numbers",
              ),
          },
        });
      }
      if (propErrors.parcels) {
        this.setState({
          parcelsError: propErrors.parcels,
        });
      }
      if (propErrors.address_to) {
        this.setState({ receiverError: parseError(propErrors.address_to) });
      }
      if (propErrors.customer_details) {
        const customerDetailsErrors = {};
        const customerErrorsObject = propErrors.customer_details;
        if (customerErrorsObject?.name) {
          customerDetailsErrors.name = parseError(customerErrorsObject.name);
        }
        if (customerErrorsObject?.email) {
          customerDetailsErrors.email = parseError(customerErrorsObject.email);
        }
        if (customerErrorsObject?.phone) {
          customerDetailsErrors.phone = parseError(customerErrorsObject.phone);
        }
        this.setState({
          receiverError: parseError(propErrors.customer_details),
          customerDetailsErrors,
        });
      }
      if (propErrors.pickup_point) {
        this.setState({ receiverError: parseError(propErrors.pickup_point) });
      }
      if (propErrors.dropoff_location) {
        this.setState({
          receiverError: parseError(propErrors.dropoff_location),
        });
      }
      if (propErrors.address_from) {
        this.setState({ senderError: parseError(propErrors.address_from) });
      }
      if (propErrors.extra_options) {
        this.setState({
          extraErrors: propErrors.extra_options,
        });
      }
    }
  };

  toggleCustoms = () => {
    this.setState({ showCustomsForm: !this.state.showCustomsForm });
  };

  toggleItemDetailsForm = () => {
    this.setState({ showItemDetailsForm: !this.state.showItemDetailsForm });
  };

  toggleRates = () => {
    this.setState({ showRates: !this.state.showRates });
  };
  togglePurchase = () => {
    this.setState({ showPurchase: !this.state.showPurchase });
  };

  setErrorMessage(addressType, error) {
    this.setState({ [`${addressType}Error`]: `${error}` });
  }

  toggleList = (type) => {
    this.setState({
      showList: !this.state.showList,
      listType: type,
    });
  };

  togglePickupPointList = () => {
    this.setState({ showPickupPointList: !this.state.showPickupPointList });
  };

  toggleDropoffLocationList = () => {
    this.setState({
      showDropoffLocationList: !this.state.showDropoffLocationList,
    });
  };
  toggleForm = (type) => {
    this.setState({
      showForm: !this.state.showForm,
      formType: type,
    });
  };

  toggleTemplate = () => {
    this.setState({
      createTemplate: !this.state.createTemplate,
      templateError: "",
    });

    this.props.clearNewTemplate();
  };

  toggleTemplateList = () => {
    this.setState({
      showTemplateList: !this.state.showTemplateList,
    });
  };

  checkShowCarriers = () => {
    const destinationAddress = this.getDestinationAddress();
    return (
      this.props.sender?.country === destinationAddress?.country ||
      (this.props.sender?.country !== destinationAddress?.country &&
        this.props.showInternational)
    );
  };

  validateFromUS(address) {
    return address.country === "US" || address.country === "USA";
  }

  validateAddress(address, addressType) {
    if (!address || !address.id || address.id === "") {
      this.setErrorMessage(
        addressType,
        "This address is not complete. Finish creating the address by clicking edit and click save when finished",
      );
      return false;
    }
    if (!!address.zip_code && address.zip_code.length > 12) {
      this.setErrorMessage(
        addressType,
        "Address postal/zip code length exceeds 12 characters.",
      );
      return false;
    }
    return true;
  }

  getRates = async (overrideTemplatePrompt = false) => {
    const pickupPoint =
      this.state.usePickupDestination && this.props.pickupPoint
        ? this.props.pickupPoint
        : null;
    const warehouse = this.state.usePickupDestination
      ? this.props.dropoffLocation
      : null;
    const to = pickupPoint ? pickupPoint.address : this.props.receiver;
    const from = warehouse ? warehouse.address : this.props.sender;
    this.setState({
      receiverError: "",
      senderError: "",
      fieldsError: { valid: true },
      customsError: { valid: true },
      parcelsError: [],
      extraErrors: null,
    });
    this.props.clearLabelCreationErrors();

    if (await this.validateRateChecks()) {
      const requestParams = {
        address_to: to,
        address_from: from,
        parcels:
          this.props.parcels?.parcels.length > 0
            ? [...this.props.parcels.parcels]
            : [{}],
        extras: this.props.selectedExtras,
        customer_details: pickupPoint
          ? {
              name: this.state.customerDetails.name?.trim(),
              phone: this.state.customerDetails.phone?.trim(),
              email: this.state.customerDetails.email?.trim(),
            }
          : undefined,
        sender_details: pickupPoint
          ? {
              name: this.props.sender?.name?.trim(),
              phone: this.props.sender?.phone?.trim(),
              email: this.props.sender?.email?.trim(),
            }
          : undefined,
      };

      if (
        !this.requiresCustoms(this.props.sender, to, pickupPoint) &&
        this.props.itemDetails?.items?.length > 0
      ) {
        requestParams["item_details"] = this.props.itemDetails.items;
      }

      if (this.requiresCustoms(this.props.sender, to, pickupPoint)) {
        const {
          certified,
          contentType,
          contentsExplanation,
          customsSigner,
          nonDeliveryOption,
          items,
          incoterm,
          eel_pfc,
          tax_numbers,
        } = this.props.customs;
        const validatedItems = items.map((item) => {
          const validatedItem = { ...item };
          if (
            Object.keys(validatedItem).includes("tariff_number") &&
            (!validatedItem.tariff_number || isNaN(validatedItem.tariff_number))
          ) {
            delete validatedItem.tariff_number;
          }
          return validatedItem;
        });
        const declaration = {
          contents_type: contentType,
          non_delivery_option: nonDeliveryOption,
          certify: certified,
          certify_signer: customsSigner,
          contents_explanation: contentsExplanation,
          incoterm,
          eel_pfc,
          items: validatedItems,
          tax_numbers,
        };
        requestParams["declaration"] = declaration;
      }

      if (
        !this.props.labelTemplate.selectedTemplate &&
        !overrideTemplatePrompt &&
        this.state.askSaveTemplate
      ) {
        this.setState({ showSaveTemplatePrompt: true });
        return;
      }
      this.props.getRates(requestParams, () =>
        this.setState({ showRates: true }),
      );
    } else {
      document.getElementsByClassName("home-content")[0].scroll({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  renderSaveTemplate = () => {
    return (
      <div className="modal">
        <div
          className="backdrop"
          onClick={() => this.setState({ showSaveTemplatePrompt: false })}
        ></div>
        <div className="modal-content save-template-prompt d-flex flex-column align-items-center text-center">
          <div className={"prompt-icon"}>
            <TemplateListIcon />
          </div>
          <div className={"col-12 col-lg-9"}>
            <p>
              The contents of the form have not been saved. Do you want to
              create a template to reuse the contents?
            </p>
          </div>
          <div className="col-12 col-lg-9 p-0 d-flex flex-column justify-content-between">
            <button
              onClick={() => {
                this.toggleTemplate();
              }}
              className="delete-button"
            >
              Create Template
            </button>
            <button
              onClick={() => {
                this.setState({
                  showSaveTemplatePrompt: false,
                  askSaveTemplate: false,
                });
                this.getRates(true);
              }}
              className={"no-bg"}
            >
              Don't Save
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderVerificationPrompt = () => {
    const { pathname } = window.location;

    return (
      <div className="modal">
        <div
          className="backdrop"
          onClick={() => {
            this.setState({ showVerificationPrompt: false });
          }}
          onKeyDown={() => {
            this.setState({ showVerificationPrompt: false });
          }}
        ></div>
        <div className="modal-content verify-details-prompt d-flex flex-column align-items-center text-center">
          <div className={"prompt-icon"}>
            <FiAlertCircle />
          </div>
          <div className={"col-12 col-lg-9"}>
            <p>{`
            ${
              missingDetails(this.props.businessDetails)
                ? "Verify your business to send international packages. Fill in the form and our team will be in touch immediately."
                : "Your business details are being verified. Our team will be in touch immediately."
            }
          `}</p>
          </div>
          <div className="col-12 col-lg-9 p-0 d-flex flex-column justify-content-between">
            <button
              onClick={() => {
                this.props.setApplicationContext(
                  { returnURL: pathname, actionType: "edit" },
                  () => {
                    history.push(ROUTES.BANK_ACCOUNT_DETAILS);
                  },
                );
              }}
              className="delete-button"
            >
              Go to Business Details
            </button>
            <button
              onClick={() => {
                this.setState({
                  showVerificationPrompt: false,
                });
              }}
              className={"no-bg"}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderKenyanVerificationPrompt = () => {
    return (
      <div className="modal">
        <div
          className="backdrop"
          onClick={() => this.setState({ showKenyanVerificationPrompt: false })}
          onKeyDown={() =>
            this.setState({ showKenyanVerificationPrompt: false })
          }
        ></div>
        <div className="modal-content verify-details-prompt d-flex flex-column align-items-center text-center">
          <div className={"prompt-icon"}>
            <FiAlertCircle />
          </div>
          <div className={"col-12 col-lg-9"}>
            <p>
              Please add your tax number to continue sending local shipments.
            </p>
          </div>
          <TaxNumberForm
            onFinish={() => {
              this.setState({ showKenyanVerificationPrompt: false });
              this.getRates();
            }}
          />
        </div>
      </div>
    );
  };

  renderError = () => {
    if (this.state.senderError !== "") {
      return `Sender Address Error: ${this.state.senderError}`;
    } else if (this.state.receiverError !== "") {
      return `Receiver Address Error: ${this.state.receiverError}`;
    } else if (!this.state.fieldsError.valid) {
      return `Package Error: ${this.state.fieldsError.message}`;
    } else if (!this.state.customsError.valid) {
      return `Customs Error: ${parseError(this.props.customs?.errors) || "Please make sure you filled out the customs declaration properly"}`;
    } else return null;
  };

  renderNextButton = () => {
    const error = this.renderError();
    return (
      <div>
        {error && <MessageBlock type={"error"} message={error} />}
        <div className="col-12 p-0 d-flex flex-row justify-content-between">
          <button className="col-12 p-0" onClick={() => this.getRates()}>
            {this.props.loading || this.props.customs.loading ? (
              <div className="spinner-border text-light"></div>
            ) : (
              "Get Rates"
            )}
          </button>
        </div>
      </div>
    );
  };

  renderSender = () => {
    return (
      <div
        className={`label-create-address sender ${this.state.senderError ? "show-error" : ""}`}
      >
        <div className="address-header col-12 p-0 d-flex justify-content-between  flex-column flex-md-row">
          <h3 className="col-12 col-md-4 p-0">Sender</h3>
          <div className="address-actions p-0 d-flex flex-row justify-content-end align-items-center mb-3">
            <a onClick={() => this.toggleList(SENDER)}>Add From List</a>
            <p>or</p>
            <a
              onClick={() => {
                this.props.clearSenderAddress();
                this.toggleForm(SENDER);
              }}
            >
              Add New Sender
            </a>
          </div>
        </div>
        {this.state.senderError && (
          <div className={"error-block"}>
            <FiAlertCircle />
            <p>{this.state.senderError}</p>
          </div>
        )}
        {this.props.sender && !!this.props.sender.id && (
          <AddressListItem
            type={SENDER}
            item={this.props.sender}
            onFinish={() => this.toggleForm(SENDER)}
            toggleForm={() => this.toggleForm(SENDER)}
            toggleAddrList={() => this.toggleList(SENDER)}
            errors={this.state.senderError}
          />
        )}
      </div>
    );
  };
  renderDestinationAddress = () => {
    return (
      <DestinationAddress
        usePickupDestination={this.state.usePickupDestination}
        canUsePickupPoints={isSenderEligibleForPickup(this.props.sender)}
        receiver={this.props.receiver}
        pickupPoint={this.props.pickupPoint}
        dropoffLocation={this.props.dropoffLocation}
        receiverError={this.state.receiverError}
        customerDetails={this.state.customerDetails}
        customerDetailsErrors={this.state.customerDetailsErrors}
        onToggleFormReceiver={() => this.toggleForm(RECEIVER)}
        onOpenReceiverList={() => this.toggleList(RECEIVER)}
        onClearReceiverAddress={this.props.clearReceiverAddress}
        onTogglePickupDestination={this.handlePickupDestinationToggle}
        onSelectCustomerFromList={() => this.toggleList(RECEIVER)}
        onCustomerDetailsChange={this.handleCustomerDetailsChange}
        onTogglePickupPointList={this.togglePickupPointList}
        onClearPickupPoint={() => this.props.selectPickupPoint(null)}
        onToggleDropoffLocationList={this.toggleDropoffLocationList}
        onClearDropoffLocation={() => this.props.selectDropoffLocation(null)}
      />
    );
  };

  renderCreateForm = () => {
    const { pathname, search } = window.location;
    return (
      <div className="settings-card label-create col-12 col-lg-6 mx-2 p-0 d-flex flex-column">
        <div className="card-section head d-flex flex-row align-items-center">
          <h3 className="create-title">Create Shipping Label</h3>
        </div>

        <div className="card-section address-selection top ">
          {this.renderSender()}
        </div>

        <div className="card-section address-selection">
          {this.renderDestinationAddress()}
        </div>

        <div className="card-section">
          <PackageDetails
            className="card-section"
            errors={this.state.fieldsError}
            parcelsError={this.state.parcelsError}
            toggleTemplateForm={() => this.toggleTemplate()}
            toggleTemplateList={() => this.toggleTemplateList()}
          />
        </div>

        <CustomsInfo
          show={this.state.showCustoms}
          toggleForm={() => this.toggleCustoms()}
          errors={this.state.customsError}
        />

        {isDomesticKenyanShipment(
          this.props.sender,
          this.getDestinationAddress(),
          this.state.usePickupDestination ? this.props.pickupPoint : null,
        ) && (
          <div className="customs-info">
            <div className="template-fields customs-items-list">
              <div>
                <label>Items Details</label>
                {this.props.itemDetails?.items?.length > 0 && (
                  <div>
                    {this.props.itemDetails.items.map((item, idx) => (
                      <CustomsItemFormItem
                        key={idx}
                        item={item}
                        itemIdx={idx}
                        showCustomsFields={false}
                        editItem={() => {
                          this.props.selectItemDetail(idx);
                          this.toggleItemDetailsForm();
                        }}
                        removeItem={() => this.props.deleteItemDetail(idx)}
                      />
                    ))}
                  </div>
                )}
                <button
                  className="customs-item d-flex justify-content-center align-items-center"
                  onClick={() => this.toggleItemDetailsForm()}
                >
                  Add Item Details
                </button>
              </div>
            </div>
          </div>
        )}

        <div className={"card-section "}>
          <ExtraOptions
            errors={this.state.extraErrors}
            pickupEnabled={this.state.usePickupDestination}
            receiverForChecks={this.getDestinationAddress()}
          />
        </div>

        <div className="card-section last">
          <div className="button-area d-flex flex-column">
            {this.renderNextButton()}
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div
        className={`labelMain col-12 p-0 m-auto d-flex flex-column flex-lg-row justify-content-lg-between ${this.props.cookies.get("is_test") ? "test-mode" : "live-mode"}`}
      >
        {this.renderCreateForm()}

        <RateSelection
          refresh={() => this.getRates()}
          toggleShow={() => this.toggleRates()}
          togglePurchase={() => this.togglePurchase()}
          showCarriers={this.checkShowCarriers()}
        />

        {this.state.showForm && (
          <AddressForm
            show={this.state.showForm}
            toggleForm={() => this.toggleForm(this.state.formType)}
            type={this.state.formType}
            onSuccess={() => {
              this.toggleForm(this.state.formType);
              this.props.getAddresses(this.props.addressPageSize);
            }}
          />
        )}
        {this.state.showList && (
          <AddressListModal
            listType={this.state.listType}
            usePickupDestination={this.state.usePickupDestination}
            onClose={() => this.toggleList(this.state.listType)}
            onPopulateCustomerDetails={this.populateCustomerDetailsFromAddress}
            selectedId={
              this.state.listType === SENDER
                ? this.props.sender?.id
                : this.props.receiver?.id
            }
          />
        )}
        {this.state.showPickupPointList && (
          <PickupPointListModal
            selectedId={this.props.pickupPoint?.id}
            onSelect={(item) => {
              this.props.selectPickupPoint(item);
              this.togglePickupPointList();
            }}
            onClose={this.togglePickupPointList}
          />
        )}
        {this.state.showDropoffLocationList && (
          <DropoffLocationListModal
            selectedId={this.props.dropoffLocation?.id}
            onSelect={(item) => {
              this.props.selectDropoffLocation(item);
              this.toggleDropoffLocationList();
            }}
            onClose={this.toggleDropoffLocationList}
          />
        )}
        {this.state.showCustomsForm && (
          <CustomsItemForm
            show={this.state.showCustomsForm}
            toggleForm={() => this.toggleCustoms()}
          />
        )}
        {this.state.showItemDetailsForm && (
          <ItemDetailsForm
            show={this.state.showItemDetailsForm}
            toggleForm={() => this.toggleItemDetailsForm()}
          />
        )}
        {this.props.selectedRate &&
          this.props.selectedRate.id &&
          this.state.showPurchase && (
            <PurchaseLabel
              toggleModal={() => this.togglePurchase()}
              showCarriers={this.checkShowCarriers()}
            />
          )}
        {this.state.createTemplate && (
          <LabelTemplate
            element={this.templateFormRef.current}
            toggleTemplate={() => this.toggleTemplate()}
            showCustoms={this.state.showCustoms}
            showCustomsForm={this.state.showCustomsForm}
            toggleCustomsForm={() => this.toggleCustoms()}
            showSaveTemplatePrompt={this.state.showSaveTemplatePrompt}
            packageDetailErrors={this.state.fieldsError}
            customsErrors={this.state.customsError}
            parcelsError={this.state.parcelsError}
            extraErrors={this.state.extraErrors}
          />
        )}
        {!this.state.showCustomsForm &&
          !this.state.createTemplate &&
          this.state.showTemplateList && (
            <TemplateList
              element={this.templateFormRef.current}
              toggleCreate={() => this.toggleTemplate()}
              toggleList={() => this.toggleTemplateList()}
              showCustoms={this.state.showCustoms}
            />
          )}
        {!this.state.createTemplate &&
          this.state.showSaveTemplatePrompt &&
          this.renderSaveTemplate()}
        {this.state.showVerificationPrompt && this.renderVerificationPrompt()}
        {this.state.showKenyanVerificationPrompt &&
          this.renderKenyanVerificationPrompt()}
      </div>
    );
  }
}

const mapStateToProps = ({
  senderAddress,
  receiverAddress,
  addressList,
  parcels,
  rateChoices,
  customs,
  labelTemplate,
  newTemplate,
  stores,
  applicationContext,
  businessDetails,
  userDetails,
  pickupPoint,
  dropoffLocation,
  itemDetails,
}) => ({
  sender: senderAddress,
  receiver: receiverAddress,
  defaultAddress: userDetails.info?.default_address,
  addressPageSize: addressList.pageSize,
  selectedExtras: parcels.selectedExtras,
  selectedParcel: parcels.selectedParcel,
  selectedWeight: parcels.selectedWeight,
  declaration: parcels.declaration,
  useTemplate: parcels.useTemplate,
  packageType: parcels.packageType,
  loading: rateChoices.loading,
  rateError: rateChoices.errors,
  rates: rateChoices.rates,
  selectedRate: rateChoices.selectedRate,
  parcels,
  customs,
  itemDetails,
  labelTemplate,
  newTemplate,
  selectedOrder: stores.selectedOrder,
  templatesIntro: labelTemplate.intro,
  currentCountry: applicationContext.context.country,
  businessDetails: businessDetails.details,
  applicationContext,
  showInternational: userDetails.info?.show_international_carriers,
  pickupPoint: pickupPoint.pickupPoint,
  dropoffLocation: dropoffLocation.dropoffLocation,
});

export default compose(
  withRouter,
  withCookies,
  connect(mapStateToProps, {
    selectAddress,
    clearSenderAddress,
    clearReceiverAddress,
    updateExtras,
    getRates,
    getAddresses,
    selectRate,
    clearCustoms,
    clearRate,
    clearRates,
    updateNewTemplate,
    createTemplate,
    updateTemplateName,
    selectTemplate,
    clearNewTemplate,
    clearSelectedTemplate,
    createCustomsDeclaration,
    editCustomsItems,
    getUserCountry,
    selectOrder,
    clearLabelCreationErrors,
    addParcelItem,
    setApplicationContext,
    clearPurchaseStates,
    getOrderForCreation,
    selectPickupPoint,
    selectDropoffLocation,
    selectItemDetail,
    deleteItemDetail,
    clearItemDetails,
  }),
)(CreateLabel);
